import React from 'react'
import { DateTime } from 'luxon'
import { DataFaker } from '@cicero/data/utils'
import { DraggableLayout, IDraggableZone, makeStyles } from '@cicero/ui'
import { IDashboardWidgetElement, IEditorWidget } from '../EditorService'

const calendarWeekZones: IDraggableZone[][] = [
  [
    { id: 'empty' },
    ...DataFaker.DATE_DAY_NAMES.map(title => ({ id: title.toLowerCase(), title })),
  ],
  ...Array(24).fill(undefined).map((s, i) => {
    const minutes = i * 60
    const display = DateTime.fromObject({ hour: Math.floor(minutes / 60), minute: minutes % 60 })
    return [
      { id: display.toFormat('hh:mm'), time: true, title: minutes % 60 === 0 ? display.toFormat('hh:mm') : '' },
      ...Array(7).fill(undefined).map((t, j) => {
        const cardCount = Math.max(0, DataFaker.gen(DataFaker.DATE_MONTHS, i * DataFaker.genSeed(`${minutes * j}`)) - 9)
        const cards = DataFaker.genFactory((seed) => ({
          title: `${DataFaker.gen(DataFaker.VERBS, seed * j * minutes)} ${DataFaker.gen(DataFaker.NOUNS, seed * i)}`,
        }), cardCount)
        return { id: `${i}-${j}`, cards }
      }),
    ]
  }),
]

export const CalendarWidget = ({}: { leaf: ICalendarWidgetConfig }) => {
  const { calWeekCell, calWeekPlacementCell, calWeekMeta, calMonthHeader } = useStyles()
  return <DraggableLayout
    classes={{ cell: calWeekCell, placementCell: calWeekPlacementCell, metaCell: calWeekMeta }}
    renderMetaSection={(zone) => <span className={calMonthHeader}>{zone.title}</span>}
    zones={calendarWeekZones}
    onDragEnd={() => {}}
  />
}

export const calendarWidget: IEditorWidget = {
  id: 'calendar',
  name: 'Calendar',
  description: 'Show events organized by date',
  image: require('./img/calendar.png'),
  renderer: (leaf: ICalendarWidgetConfig) => <CalendarWidget leaf={leaf} />,
}

export type CalendarStrategyType = 'day'
export interface ICalendarWidgetConfig extends IDashboardWidgetElement {
  view?: CalendarStrategyType
}

const useStyles = makeStyles({
  calMonthHeader: {
    color: '#CCC',
    padding: 4,
  },
  calWeekPlacementCell: {
    height: 70,
    overflow: 'visible',
    position: 'relative',
  },
  calWeekCell: {
    borderRight: '1px solid #EEE',
    borderBottom: '1px solid #EEE',
  },
  calWeekMeta: {
    padding: 6,
    textAlign: 'center',
  },
  metaCell: {
    padding: 6,
    textAlign: 'center',
  },
})
